export default {
      id: "ic_ekuri_horse-usage",
      viewBox: "0 0 11 10",
      url: "/" + "images/icons.3.109.2.svg#ic_ekuri_horse-usage",
      toString: function () {
        return this.url;
      }
    }